/* eslint-disable react/prop-types */
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import { useQuery, useLazyQuery } from "@apollo/client";
import { Box } from "@material-ui/core";

import { GET_COURSE_INQUIRIES } from "graphql/query/admin";
import Table from "Components/Table/Table";
import { formStyles } from "../listStyles";

const Inquiries = ({ setErrorMsg, actionPerformed, setActionPerformed }) => {
  const navigate = useNavigate();
  const classes = formStyles();
  const [inquiries, setInquiries] = useState([]);
  const [pageInfo, setPageInfo] = useState("");
  const [page, setPage] = useState(0);

  const { data, refetch, error, loading } = useQuery(GET_COURSE_INQUIRIES, {
    variables: {
      first: 10,
      orderBy: "createdAt_DESC",
      filters: {},
    },
    fetchPolicy: "network-only",
  });

  const [getNextPage, { loading: nextPageLoader }] = useLazyQuery(
    GET_COURSE_INQUIRIES
  );
  const [getPrevPage, { loading: prevPageLoader }] = useLazyQuery(
    GET_COURSE_INQUIRIES
  );

  const mapList = (edges) => edges.map((c) => ({ ...c.node }));

  const handleNextPage = async () => {
    if (pageInfo.hasNextPage) {
      const nextPageData = await getNextPage({
        variables: {
          first: 10,
          after: pageInfo.endCursor,
          orderBy: "createdAt_DESC",
          filters: {},
        },
        fetchPolicy: "network-only",
      });
      if (nextPageData.data.courseInquiries) {
        setInquiries(mapList(nextPageData.data.courseInquiries.edges));
        setPage(page + 1);
        setPageInfo(nextPageData.data.courseInquiries.pageInfo);
        setErrorMsg("");
      }
    }
  };

  const handlePreviousPage = async () => {
    if (pageInfo.hasPreviousPage) {
      const prevPageData = await getPrevPage({
        variables: {
          last: 10,
          before: pageInfo.startCursor,
          orderBy: "createdAt_DESC",
          filters: {},
        },
        fetchPolicy: "network-only",
      });
      if (prevPageData.data.courseInquiries) {
        setInquiries(mapList(prevPageData.data.courseInquiries.edges));
        setPage(page - 1);
        setPageInfo(prevPageData.data.courseInquiries.pageInfo);
        setErrorMsg("");
      }
    }
  };

  const setAllInquiries = () => {
    if (data && data.courseInquiries) {
      setPageInfo(data.courseInquiries.pageInfo);
      setInquiries(mapList(data.courseInquiries.edges));
      setErrorMsg("");
    }
    setPage(0);
  };

  useEffect(() => {
    if (actionPerformed) {
      refetch();
      setActionPerformed(false);
    }
    if (error) {
      setErrorMsg("Error in loading data !");
    }
    setAllInquiries();
  }, [data, actionPerformed, error]);

  const handleViewButton = (id) => {
    navigate("/admin/course/view-inquiry", { state: { id } });
  };

  const TABLE_HEAD = [
    { id: "id", flag: "id", label: "No.", alignRight: false },
    { id: "title", flag: "title", label: "Title", alignRight: false },
    { id: "email", flag: "email", label: "Email", alignRight: false },
    { id: "mobile", flag: "mobile", label: "Mobile", alignRight: false },
    { id: "status", flag: "status", label: "Status", alignRight: false },
    { id: "createdAt", flag: "createdAt", label: "Created At", alignRight: false },
    {
      id: "actions",
      flag: { read: true },
      callback: { handleViewButton },
      label: "Actions",
      alignRight: false,
    },
  ];

  return (
    <Box className={classes.mainContainer}>
      <Table
        error={error}
        USERLIST={inquiries}
        page={page}
        handleNextPage={handleNextPage}
        handlePreviousPage={handlePreviousPage}
        TABLE_HEAD={TABLE_HEAD}
        pageInfo={pageInfo}
        loading={loading || nextPageLoader || prevPageLoader}
      />
    </Box>
  );
};

export default Inquiries;
